var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"layout"}},[_c('main',{staticStyle:{"overflow":"hidden"}},[_c('menu-bar'),_c('app-content'),_c('footer-bar')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }